module.exports = __webpack_public_path__ + "img/img_level_8.6b9d66fa.png";